import React from "react";
import {Grid} from "@mui/material";
import TemplateCard from "./TemplateCard";
import CreateTemplateButton from "./CreateTemplateButton"
import {useGetTemplatesByTypeQuery} from "../../../services/Template/templateSlice";
import CenteredLoading from "../../../layout/CenteredLoading";
import {MODULE_TYPE_LIST} from "../../../config/moduleTypes";

const sortByNewest = (data) =>
    data ? [...data].sort((a, b) => new Date(b.creationDateTime) - new Date(a.creationDateTime)) : [];

const TemplateTab = () => {
    // Used to be 5 hardcoded useGetXTemplatesQuery() calls, one per module type, plus a 5-way OR
    // of their isLoading flags and 5 near-identical .map() blocks below. MODULE_TYPE_LIST is a
    // fixed-length constant (computed once at module load from config/moduleTypes.js), so calling
    // the one parameterized hook once per entry here is equivalent to — and replaces — those 5
    // separate calls. A 6th module type needs zero changes in this file.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const results = MODULE_TYPE_LIST.map((type) => useGetTemplatesByTypeQuery(type.key));

    const isLoading = results.some((r) => r.isLoading);

    return (
        <Grid
            container
            rowSpacing={3}
            columnSpacing={{xs: 1, sm: 1, md: 2}}
            maxWidth="xl"
        >
            {isLoading && (
                <CenteredLoading tekst={'Laster inn…'}/>
            )}
            {!isLoading && (
                <>
                    <Grid item>
                        <CreateTemplateButton fontHeader={18} width={250} height={240}/>
                    </Grid>

                    {MODULE_TYPE_LIST.map((type, i) =>
                        sortByNewest(results[i].data?.data).map((data, j) => (
                            <TemplateCard
                                data={data}
                                endpoint={type.endpoints.delete}
                                // TemplateCard resolves this itself via modulePackageName/
                                // getModuleTypeColor, so the canonical registry key (not the
                                // display label) is what it needs here — matches what the
                                // original 5 hardcoded blocks effectively passed ('Mental',
                                // 'Fysisk', ... all lowercase-resolve to the same keys).
                                label={type.key}
                                key={`${type.key}-${j}`}
                            />
                        ))
                    )}
                </>
            )}
        </Grid>
    );
};

export default TemplateTab;
